import {useMateApi} from "./useMateApi";
import {AccessToken} from "./types";

type FileFormat = "csv" | "pdf" | "json" | "txt" | "xlsx" | "xml" | "zip" | "html";

type Options = {
    filename?: string;
    newTab?: boolean;
    format?: FileFormat
}

const mimeDict: Record<FileFormat, string> = {
    "csv": "text/csv",
    "pdf": "application/pdf",
    "json": "application/json",
    "txt": "text/plain",
    "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "xml": "application/xml",
    "zip": "application/zip",
    "html": "text/html"
}

export const getAcceptHeader = (format: FileFormat | undefined) => ({
    "Accept": format
        ? mimeDict[format]
        : <any>undefined
})

export const isString = (value: any): value is string => typeof value === "string";


export const useDownloadHelper = (accessToken: AccessToken) => {

    const {authorizationHeader, acceptLanguageHeader, baseUrl: baseURL, axiosInstance, endpoint} = useMateApi(accessToken);

    const download = (url: string, options?: Options): Promise<void> =>
        axiosInstance
            .get<Blob>(url, {
                //baseURL,
                responseType: "blob",
                headers: {
                    ...authorizationHeader(),
                    ...acceptLanguageHeader(),
                    ...getAcceptHeader(options?.format)
                }
            })
            .then(response =>
                response.data.text().then(buffer => {
                    const content = response.data;
                    if (isString(content) && content.startsWith("<Fault")) {
                        const xml = new DOMParser().parseFromString(content, "application/xml");
                        const message = xml?.documentElement?.getElementsByTagName("Reason")[0]?.getElementsByTagName("Text")[0]?.textContent;
                        throw {message: message || "Failed"};
                    }

                    let fallbackFilename = "";
                    
                    const contentDisposition = response.headers["content-disposition"];
                    if (contentDisposition) {
                        const res = new RegExp(/filename="(.*)"/g).exec(contentDisposition);
                        if (res) {
                            fallbackFilename = res[1];
                        }
                        const resUtf8 = new RegExp(/attachment; filename=(.*); filename\*=UTF-8''(.*)/g).exec(contentDisposition);
                        if (resUtf8) {
                            fallbackFilename = resUtf8[2];
                        }
                    }

                    const a = document.createElement("a");
                    a.target = options?.newTab ? "_blank" : "_self";
                    a.download = options?.filename || fallbackFilename;
                    a.href = URL.createObjectURL(content);
                    a.click();
                }))

    return {
        download
    }

}